// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.airdrop_page {
  background: #000;
  color: #fff;
}

.airdrop_hero {
  padding: 100px 0 120px;
  position: relative;
  overflow: hidden;
  /* Hero BG image: set via inline style in index.js (PUBLIC_URL) — webpack cannot resolve public/ URLs in imported CSS */
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
}


.airdrop_hero_content h1 {
  font-size: 97px;
  line-height: 1.20;
  font-weight: 500;
  letter-spacing: -0.5px;
  margin: 0 0 14px;
}

.airdrop_hero_content p {
  max-width: 100%;
  color: rgba(255, 255, 255, 0.95);
  font-size: 24px;
  line-height: 1.45;
  font-weight: 300;
  margin: 0 0 20px;
}

.airdrop_hero_actions {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  margin: 36px 0px 22px;
}

.airdrop_btn_primary,
.airdrop_btn_secondary {
  border-radius: 50px;
  padding: 12px 18px;
  font-size: 15px;
  font-weight: 400;
  border: 1px solid #44444460;
  ;
  transition: 0.2s ease;
}

.joined_user {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #99A1AF;
  font-size: 14px;
  font-weight: 400;
  margin-top: 20px;
}

.joined_user span b {
  color: #fff;
}

img.airdrop_back_img {
  position: absolute;
  bottom: -95px;
  left: 0px;
}

.airdrop_btn_primary {
  background: #1E56F5;
  color: #fff;
  border-color: transparent;
}

.airdrop_btn_primary:hover {
  transform: translateY(-1px);
  filter: brightness(1.05);
}

.airdrop_btn_secondary {
  background: linear-gradient(0deg, rgba(30, 86, 245, 0.3) 0%, rgba(30, 86, 245, 0) 100%);
  color: #fff;
}

.airdrop_btn_secondary:hover {
  background: rgba(255, 255, 255, 0.10);
  transform: translateY(-1px);
}

.airdrop_social_row {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 6px;
}

.airdrop_social {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.10);
  color: #fff;
  text-decoration: none;
  transition: 0.2s ease;
}

.airdrop_social:hover {
  background: rgba(255, 255, 255, 0.10);
  transform: translateY(-1px);
}

.airdrop_hero_visual {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
}

.airdrop_visual_glow {
  position: absolute;
  width: min(440px, 80%);
  aspect-ratio: 1 / 1;
  border-radius: 999px;
  background: radial-gradient(circle at 50% 50%, rgba(129, 76, 255, 0.35), rgba(72, 117, 247, 0.18), transparent 62%);
  filter: blur(8px);
}

.airdrop_visual_img {
  position: relative;
  max-width: min(550px, 90%);
  height: auto;
  transform: translateY(6px);
  z-index: 999;
  top: -80px;
}

.airdrop_stats {
  margin-top: 28px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

.airdrop_stat_card {
  padding: 14px 28px;
  border-radius: 18px;
  background: #1B072A;
  border: 1px solid #ad46ff38;
  display: flex;
  gap: 24px;
  flex-direction: column;
  justify-content: center;
  min-height: 190px;
  align-items: start;
}

.airdrop_stat_icon {
  width: 40px;
  margin: 0 auto;
  height: 40px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.airdrop_stat_icon--purple {
  background: linear-gradient(135deg, rgba(129, 76, 255, 0.9), rgba(129, 76, 255, 0.25));
}

.airdrop_stat_icon--blue {
  background: linear-gradient(135deg, rgba(72, 117, 247, 0.9), rgba(72, 117, 247, 0.25));
}

.airdrop_stat_icon--green {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.9), rgba(34, 197, 94, 0.25));
}

.airdrop_stat_icon--orange {
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.9), rgba(245, 158, 11, 0.25));
}

.airdrop_stat_card.airdrop_stat_card_green {
  background: #04190D;
  border: 1px solid #00C95038;
}

.airdrop_stat_card.airdrop_stat_card_green .airdrop_stat_text h4 {
  color: #05DF72;
}

.airdrop_stat_card.airdrop_stat_card_orange {
  background: #221303;
  border: 1px solid #F0B10038;
}

.airdrop_stat_card.airdrop_stat_card_orange .airdrop_stat_text h4 {
  color: #FDC700;
}


.airdrop_stat_card.airdrop_stat_card_blue {
  background: #08112B;
  border: 1px solid #2B7FFF38;
}

.airdrop_stat_card.airdrop_stat_card_blue .airdrop_stat_text h4 {
  color: #51A2FF;
}



.airdrop_stat_text h4 {
  margin: 0;
  font-weight: 700;
  font-size: 26px;
  color: #C27AFF;
  margin-bottom: 3px;
  line-height: 1.1;
}

.airdrop_stat_text p {
  margin: 0;
  color: rgba(255, 255, 255, 0.72);
  font-size: 16px;
}

.airdrop_steps,
.airdrop_rewards,
.airdrop_release {
  padding: 100px 0 0px
}

#airdrop-tasks {
  scroll-margin-top: clamp(72px, 12vw, 108px);
}

.airdrop_steps h2,
.airdrop_rewards h2,
.airdrop_release h2 {
  text-align: center;
  font-weight: 500;
  letter-spacing: -0.3px;
  margin: 0 0 10px;
  font-size: clamp(34px, 3.2vw, 52px);
}

section.airdrop_steps h2 span {
  color: #1E56F5;
}

.airdrop_step_card {
  height: 100%;
  padding: 15px;
  text-align: center;
}

.airdrop_step_num {
  width: 80px;
  height: 80px;
  border-radius: 50px;
  font-size: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  margin-bottom: 18px;
}

.airdrop_step_num--pink {
  background: #9810FA;
}

.airdrop_step_num--blue {
  background: #155DFC;
}

.airdrop_step_num--green {
  background: #00A63E;
}

.airdrop_task_social_badge i {
  font-size: clamp(34px, 5vw, 42px);
  line-height: 1;
  color: #fff;
}

.airdrop_step_card h3 {
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.52px;
  margin: 0 0 8px;
}

.airdrop_step_card p {
  margin: 0px;
  color: rgba(255, 255, 255, 0.76);
  font-size: 18px;
  letter-spacing: -0.38px;
  line-height: 1.45;
  padding-top: 3px;
}

.airdrop_section_heading {
  text-align: center;
}

.airdrop_section_heading p {
  margin: 0;
  color: rgb(255 255 255 / 90%);
  font-size: 18px;
}

.airdrop_reward_card {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 36px;
  background-image: var(--airdrop-bonusbg);
  background-repeat: no-repeat;
  background-size: 100%;
  min-height: 410px;
}

.token_rewards_sl {
  padding-top: 24px;
}

section.airdrop_release h2 span {
  color: #1E56F5;
}

.airdrop_reward_top {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: baseline;
  gap: 2px;
}

.airdrop_reward_meta_item {
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.airdrop_reward_meta_item b {
  color: #51A2FF;
  font-weight: 400;
}

.airdrop_reward_top h3 {
  margin: 0;
  font-size: 30px;
  font-weight: 600;
}

.airdrop_reward_value {
  font-weight: 700;
  font-size: 62px;
  background: #51A2FF;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.airdrop_reward_sub {
  margin: 10px 0 12px;
  color: rgba(255, 255, 255, 0.76);
  font-size: 18px;
  line-height: 1.45;
  letter-spacing: -0.38px;
}

.airdrop_reward_meta {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 15px;
}

.airdrop_reward_meta span {
  font-size: 18px;
  align-items: center;
  gap: 10px;
  display: flex;
  color: #D1D5DC;
  font-weight: 300;
}

.airdrop_reward_rows {
  display: grid;
  gap: 10px;
}

.airdrop_reward_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.10);
  font-size: 15px;
}

.airdrop_reward_row b {
  font-weight: 900;
}

.airdrop_cta_row {
  margin-top: 18px;
  display: flex;
  justify-content: center;
}

.airdrop_cta_link {
  color: #fff;
  text-decoration: none;
  font-weight: 700;
  font-size: 13px;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.airdrop_cta_link:hover {
  background: rgba(255, 255, 255, 0.10);
}

.airdrop_release_card {
  height: 100%;
  padding: 18px 18px 40px;
  border-radius: 18px;
  background-image: var(--airdrop-releasebg);
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  position: relative;
  border: 1px solid #1e57f564;
  overflow: hidden;
}

body.light_theme .airdrop_release_card {
  background-image: var(--airdrop-releasebg-light);
}

body.light_theme .airdrop_release_sub {
  color: rgb(0 0 0); }


body.light_theme .airdrop_release_time {
    color: rgb(4 4 4 / 80%);
}

body.light_theme .airdrop_release_badge {
  box-shadow: none;
  color: #fff;
  background: #1E56F5;
}

body.light_theme .airdropsubtext {
  color: #656565; }

section.airdrop_release {
  padding-bottom: 100px;
}

.airdrop_release_card::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(360px 160px at 50% 10%, rgba(72, 117, 247, 0.28), transparent 60%);
  pointer-events: none;
}

.airdrop_release_badge {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 2;
  font-weight: 500;
  font-size: 15px;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.9);
  padding: 6px 32px;
  border-radius: 18px 0px 18px 0px;
  background: #3455B3;
}

.airdrop_release_icon {
  position: relative;
  z-index: 2;
  width: 93px;
  margin: 18px auto 12px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.airdrop_release_card h6 {
  font-size: 16px;
  font-weight: 400;
  margin: 18px 0px;
}

.airdrop_release_pct {
  position: relative;
  z-index: 2;
  font-size: 40px;
  line-height: 45px;
  font-weight: 700;
  margin: 0px 0 0px;
}

.airdrop_release_sub {
  position: relative;
  z-index: 2;
  color: rgb(255 255 255);
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px;
}

.airdrop_release_time {
  position: relative;
  z-index: 2;
  margin-top: 32px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.80);
}

.airdropsubtext {
  font-size: 13px;
  color: #b2b7bf;
  margin-top: 9px;
}


body.light_theme .airdrop_hero{ background-image: var(--airdrop-hero-light-bg) !important; }

body.light_theme img.dark_img {
  display: none;
}

body.light_theme img.light_img {
  display: block;
}

img.light_img{ display: none; }

body.light_theme .joined_user {
  color: #787c84; }

  body.light_theme .joined_user span b {
    color: #030303;
}  


@media (max-width: 991px) {
  .airdrop_stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 575px) {
  .airdrop_hero {
    padding-top: 52px;
  }

  .airdrop_stats {
    grid-template-columns: 1fr;
  }
}

body.light_theme .airdrop_page {
  background: radial-gradient(900px 400px at 30% 10%, rgba(129, 76, 255, 0.14), transparent 60%),
    radial-gradient(700px 380px at 70% 20%, rgba(72, 117, 247, 0.12), transparent 60%),
    #ffffff;
  color: #0c0900;
}

body.light_theme .airdrop_step_card p{
  color: rgba(16, 16, 16, 0.7);
}

body.light_theme .airdrop_step_num {
  color: #fff; }

  body.light_theme .airdrop_reward_sub {
    color: rgb(0 0 0 / 76%);}  

body.light_theme .airdrop_reward_meta span {
      color: #454545; }

    body.light_theme .airdrop_section_heading p {
        color: rgb(26 26 26 / 90%); }      

body.light_theme .airdrop_hero_content p {
  color: rgb(4 4 4 / 95%); }

/* body.light_theme .airdrop_step_card,
body.light_theme .airdrop_reward_card,
body.light_theme .airdrop_release_card,
body.light_theme .airdrop_stat_card,
body.light_theme .airdrop_cta_link,
body.light_theme .airdrop_social {
  background: rgba(12, 9, 0, 0.04);
  border: 1px solid rgba(12, 9, 0, 0.10);
} */

body.light_theme .airdrop_btn_secondary {
  background: rgba(12, 9, 0, 0.04);
  border: 1px solid rgba(12, 9, 0, 0.10);
  color: #0c0900;
}


@media (max-width: 1440px) {

  .airdrop_visual_img {
    max-width: min(450px, 90%);
  }

  .airdrop_hero_content h1 {
    font-size: 75px;
  }

  .airdrop_hero_content p {
    font-size: 20px;
  }

}



@media (max-width: 1366px) {

  .airdrop_visual_img {
    max-width: min(370px, 90%);
  }

  .airdrop_hero_content h1 {
    font-size: 60px;
  }

  .airdrop_hero_content p {
    font-size: 18px;
  }

  .airdrop_steps h2,
  .airdrop_rewards h2,
  .airdrop_release h2 {
    font-size: 38px;
  }

  section.airdrop_release {
    padding-bottom: 60px;
  }

  .airdrop_steps,
  .airdrop_rewards,
  .airdrop_release {
    padding: 60px 0 0px;
  }

  .airdrop_reward_value {
    font-size: 40px;
  }

  .airdrop_reward_top h3 {
    font-size: 20px;
  }

  .airdrop_reward_sub {
    font-size: 16px;
  }

  .airdrop_reward_meta span {
    font-size: 16px;
  }

}


@media (max-width: 1024px) {
  .airdrop_hero_content h1 {
    font-size: 42px;
  }

  .airdrop_visual_img {
    max-width: min(310px, 90%);
  }

  img.airdrop_back_img {
    bottom: -35px;
  }

  .airdrop_step_card h3 {
    font-size: 20px;
  }

  .airdrop_step_card p {
    font-size: 15px;
  }

  .token_rewards_sl {
    flex-direction: column;
  }

  .token_rewards_sl .col-lg-6 {
    width: 100%;
  }

  .airdrop_reward_card {
    background-size: contain;
    min-height: 360px;
    width: 590px;
    margin: 0 auto;
  }

  .airdrop_release_pct {
    font-size: 28px;
  }


}

@media (max-width: 991px) {

  .airdrop_hero {
    padding: 40px 0 80px;
    text-align: center;
  }

  .airdrop_hero_content h1 br {
    display: none;
  }

  img.airdrop_back_img {
    width: 270px;
    margin: 0 auto;
    right: 0px;
  }

  .airdrop_visual_img {
    max-width: min(200px, 90%);
    top: -30px;
  }

  .airdrop_hero_visual {
    margin-top: 42px;
  }

  .airdrop_hero_actions {
    justify-content: center;
    margin: 24px 0px 22px;
  }

  .joined_user {
    justify-content: center;
  }


}


@media (max-width:767px) {

  .airdrop_hero_content h1 {
    font-size: 32px;
  }

  .airdrop_hero_content p {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .airdrop_hero_actions {
    gap: 10px;
  }

  .airdrop_btn_primary,
  .airdrop_btn_secondary {
    padding: 10px 16px;
    font-size: 13px;
  }

  .airdrop_hero {
    padding: 40px 0 50px;
  }

  .airdrop_stat_text h4 {
    font-size: 24px;
  }

  .airdrop_steps h2,
  .airdrop_rewards h2,
  .airdrop_release h2 {
    font-size: 26px;
  }

  .airdrop_step_num {
    width: 60px;
    height: 60px;
    font-size: 22px;
  }

  .airdrop_steps, .airdrop_rewards, .airdrop_release {
    padding: 40px 0 0px;
} 
.token_rewards_sl {
  padding-top: 0px;
}

.airdrop_reward_card {
  background-size: 100% 100%;
  width: 100%;
  padding: 28px; }

  .airdrop_reward_value {
    font-size: 36px;
}


}

.airdrop_steps_logged_sub {
  text-align: center;
  max-width: 640px;
  margin: 12px auto 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 17px;
  line-height: 1.5;
}

.airdrop_onboarding_load {
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
}

.airdrop_task_progress {
  max-width: 900px;
  margin: 24px auto 8px;
  padding: 16px 18px 14px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.airdrop_task_progress_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.airdrop_task_progress_label {
  font-size: 15px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
}

.airdrop_task_progress_count {
  font-size: 14px;
  font-weight: 500;
  color: #7dd3fc;
  white-space: nowrap;
}

.airdrop_task_progress_track {
  height: 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  overflow: hidden;
}

.airdrop_task_progress_fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #155dfc 0%, #4ade80 100%);
  transition: width 0.35s ease;
  min-width: 0;
}

.airdrop_task_progress_steps {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.airdrop_task_progress_step {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
}

.airdrop_task_progress_icon_circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.06);
  border: 2px solid rgba(255, 255, 255, 0.22);
  color: rgba(255, 255, 255, 0.85);
}

.airdrop_task_progress_icon_circle i {
  font-size: 20px;
  line-height: 1;
}

.airdrop_task_progress_step.is-done .airdrop_task_progress_icon_circle {
  background: rgba(34, 197, 94, 0.2);
  border-color: #4ade80;
  color: #86efac;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.2);
}

.airdrop_task_progress_step.is-todo .airdrop_task_progress_icon_circle {
  opacity: 0.88;
}

.airdrop_task_progress_stepname {
  font-size: 12px;
  line-height: 1.25;
  color: rgba(255, 255, 255, 0.7);
  word-break: break-word;
}

.airdrop_task_progress_step.is-done .airdrop_task_progress_stepname {
  color: #86efac;
  font-weight: 500;
}

.airdrop_task_card--done {
  border: 1px solid rgba(0, 166, 62, 0.45);
  border-radius: 16px;
  background: rgba(0, 166, 62, 0.08);
}

.airdrop_task_done_badge {
  color: #4ade80;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 6px;
}

.airdrop_task_hint {
  font-size: 16px;
  line-height: 1.4;
  margin: 0 0 16px;
  color: rgba(255, 255, 255, 0.78);
}

.airdrop_task_actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: auto;
  padding-top: 8px;
}

.airdrop_task_link_out {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border-radius: 50px;
  padding: 10px 16px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: #1e56f5;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 14px rgba(30, 86, 245, 0.35);
  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
}

.airdrop_task_link_out:hover {
  background: #2f64fb;
  color: #fff;
  box-shadow: 0 6px 18px rgba(30, 86, 245, 0.45);
}

.airdrop_task_link_out:focus-visible {
  outline: 2px solid #93c5fd;
  outline-offset: 2px;
}

.airdrop_task_link_out:active:not([aria-busy="true"]) {
  transform: scale(0.98);
}

.airdrop_task_mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  padding: 10px 16px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  color: #fff;
  background: #1E56F5;
  border: 1px solid transparent;
  transition: 0.2s ease;
}

.airdrop_task_mark:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.airdrop_task_mark:hover:not(:disabled) {
  filter: brightness(1.06);
}

body.light_theme .airdrop_steps_logged_sub {
  color: rgba(0, 0, 0, 0.65);
}

body.light_theme .airdrop_task_progress {
  background: rgba(0, 0, 0, 0.04);
  border-color: rgba(0, 0, 0, 0.1);
}

body.light_theme .airdrop_task_progress_label {
  color: rgba(0, 0, 0, 0.88);
}

body.light_theme .airdrop_task_progress_count {
  color: #1E56F5;
}

body.light_theme .airdrop_task_hint {
  color: rgba(0, 0, 0, 0.7);
}

body.light_theme .airdrop_task_link_out {
  background: #1e56f5;
  border-color: rgba(30, 86, 245, 0.5);
  box-shadow: 0 4px 14px rgba(30, 86, 245, 0.25);
}

body.light_theme .airdrop_task_link_out:hover {
  background: #1847cf;
}

body.light_theme .airdrop_task_link_out:focus-visible {
  outline-color: #2563eb;
}

body.light_theme .airdrop_task_progress_icon_circle {
  background: rgba(0, 0, 0, 0.04);
  border-color: rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.72);
}

body.light_theme .airdrop_task_progress_step.is-done .airdrop_task_progress_icon_circle {
  background: rgba(34, 197, 94, 0.12);
  border-color: #22c55e;
  color: #15803d;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.18);
}

body.light_theme .airdrop_task_progress_stepname {
  color: rgba(0, 0, 0, 0.55);
}

body.light_theme .airdrop_task_progress_step.is-done .airdrop_task_progress_stepname {
  color: #15803d;
}

body.light_theme .airdrop_task_progress_track {
  background: rgba(0, 0, 0, 0.08);
}

@media (max-width: 767px) {
  .airdrop_task_progress_steps {
    flex-direction: column;
    align-items: stretch;
  }

  .airdrop_task_progress_step {
    flex-direction: row;
    justify-content: flex-start;
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/AirDrop/airdrop.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,uHAAuH;EACvH,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;AAC9B;;;AAGA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;;EAE3B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,uFAAuF;EACvF,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,2CAA2C;EAC3C,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,mHAAmH;EACnH,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;;;AAIA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;;EAGE;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,wCAAwC;EACxC,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,iBAAiB,EAAE;;;AAGrB;IACI,uBAAuB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE;;AAElB;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,8FAA8F;EAC9F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;;AAGA,gCAAgC,yDAAyD,EAAE;;AAE3F;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe,aAAa,EAAE;;AAE9B;EACE,cAAc,EAAE;;EAEhB;IACE,cAAc;AAClB;;;AAGA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;WAES;EACT,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW,EAAE;;EAEb;IACE,uBAAuB,CAAC;;AAE5B;MACM,cAAc,EAAE;;IAElB;QACI,0BAA0B,EAAE;;AAEpC;EACE,uBAAuB,EAAE;;AAE3B;;;;;;;;GAQG;;AAEH;EACE,gCAAgC;EAChC,sCAAsC;EACtC,cAAc;AAChB;;;AAGA;;EAEE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;;AAIA;;EAEE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;AAGA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;IACjB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;;AAGF;;AAEA;;EAEE;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;;AAGF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,mBAAmB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,aAAa,EAAE;;EAEf;IACE,eAAe;AACnB;;;AAGA;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,4DAA4D;EAC5D,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,0CAA0C;EAC1C,8CAA8C;EAC9C,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;EAClB;AACF","sourcesContent":[".airdrop_page {\n  background: #000;\n  color: #fff;\n}\n\n.airdrop_hero {\n  padding: 100px 0 120px;\n  position: relative;\n  overflow: hidden;\n  /* Hero BG image: set via inline style in index.js (PUBLIC_URL) — webpack cannot resolve public/ URLs in imported CSS */\n  background-size: cover;\n  background-position: center bottom;\n  background-repeat: no-repeat;\n}\n\n\n.airdrop_hero_content h1 {\n  font-size: 97px;\n  line-height: 1.20;\n  font-weight: 500;\n  letter-spacing: -0.5px;\n  margin: 0 0 14px;\n}\n\n.airdrop_hero_content p {\n  max-width: 100%;\n  color: rgba(255, 255, 255, 0.95);\n  font-size: 24px;\n  line-height: 1.45;\n  font-weight: 300;\n  margin: 0 0 20px;\n}\n\n.airdrop_hero_actions {\n  display: flex;\n  gap: 24px;\n  flex-wrap: wrap;\n  margin: 36px 0px 22px;\n}\n\n.airdrop_btn_primary,\n.airdrop_btn_secondary {\n  border-radius: 50px;\n  padding: 12px 18px;\n  font-size: 15px;\n  font-weight: 400;\n  border: 1px solid #44444460;\n  ;\n  transition: 0.2s ease;\n}\n\n.joined_user {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #99A1AF;\n  font-size: 14px;\n  font-weight: 400;\n  margin-top: 20px;\n}\n\n.joined_user span b {\n  color: #fff;\n}\n\nimg.airdrop_back_img {\n  position: absolute;\n  bottom: -95px;\n  left: 0px;\n}\n\n.airdrop_btn_primary {\n  background: #1E56F5;\n  color: #fff;\n  border-color: transparent;\n}\n\n.airdrop_btn_primary:hover {\n  transform: translateY(-1px);\n  filter: brightness(1.05);\n}\n\n.airdrop_btn_secondary {\n  background: linear-gradient(0deg, rgba(30, 86, 245, 0.3) 0%, rgba(30, 86, 245, 0) 100%);\n  color: #fff;\n}\n\n.airdrop_btn_secondary:hover {\n  background: rgba(255, 255, 255, 0.10);\n  transform: translateY(-1px);\n}\n\n.airdrop_social_row {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-top: 6px;\n}\n\n.airdrop_social {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  color: #fff;\n  text-decoration: none;\n  transition: 0.2s ease;\n}\n\n.airdrop_social:hover {\n  background: rgba(255, 255, 255, 0.10);\n  transform: translateY(-1px);\n}\n\n.airdrop_hero_visual {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 280px;\n}\n\n.airdrop_visual_glow {\n  position: absolute;\n  width: min(440px, 80%);\n  aspect-ratio: 1 / 1;\n  border-radius: 999px;\n  background: radial-gradient(circle at 50% 50%, rgba(129, 76, 255, 0.35), rgba(72, 117, 247, 0.18), transparent 62%);\n  filter: blur(8px);\n}\n\n.airdrop_visual_img {\n  position: relative;\n  max-width: min(550px, 90%);\n  height: auto;\n  transform: translateY(6px);\n  z-index: 999;\n  top: -80px;\n}\n\n.airdrop_stats {\n  margin-top: 28px;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 14px;\n}\n\n.airdrop_stat_card {\n  padding: 14px 28px;\n  border-radius: 18px;\n  background: #1B072A;\n  border: 1px solid #ad46ff38;\n  display: flex;\n  gap: 24px;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 190px;\n  align-items: start;\n}\n\n.airdrop_stat_icon {\n  width: 40px;\n  margin: 0 auto;\n  height: 40px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n\n.airdrop_stat_icon--purple {\n  background: linear-gradient(135deg, rgba(129, 76, 255, 0.9), rgba(129, 76, 255, 0.25));\n}\n\n.airdrop_stat_icon--blue {\n  background: linear-gradient(135deg, rgba(72, 117, 247, 0.9), rgba(72, 117, 247, 0.25));\n}\n\n.airdrop_stat_icon--green {\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.9), rgba(34, 197, 94, 0.25));\n}\n\n.airdrop_stat_icon--orange {\n  background: linear-gradient(135deg, rgba(245, 158, 11, 0.9), rgba(245, 158, 11, 0.25));\n}\n\n.airdrop_stat_card.airdrop_stat_card_green {\n  background: #04190D;\n  border: 1px solid #00C95038;\n}\n\n.airdrop_stat_card.airdrop_stat_card_green .airdrop_stat_text h4 {\n  color: #05DF72;\n}\n\n.airdrop_stat_card.airdrop_stat_card_orange {\n  background: #221303;\n  border: 1px solid #F0B10038;\n}\n\n.airdrop_stat_card.airdrop_stat_card_orange .airdrop_stat_text h4 {\n  color: #FDC700;\n}\n\n\n.airdrop_stat_card.airdrop_stat_card_blue {\n  background: #08112B;\n  border: 1px solid #2B7FFF38;\n}\n\n.airdrop_stat_card.airdrop_stat_card_blue .airdrop_stat_text h4 {\n  color: #51A2FF;\n}\n\n\n\n.airdrop_stat_text h4 {\n  margin: 0;\n  font-weight: 700;\n  font-size: 26px;\n  color: #C27AFF;\n  margin-bottom: 3px;\n  line-height: 1.1;\n}\n\n.airdrop_stat_text p {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.72);\n  font-size: 16px;\n}\n\n.airdrop_steps,\n.airdrop_rewards,\n.airdrop_release {\n  padding: 100px 0 0px\n}\n\n#airdrop-tasks {\n  scroll-margin-top: clamp(72px, 12vw, 108px);\n}\n\n.airdrop_steps h2,\n.airdrop_rewards h2,\n.airdrop_release h2 {\n  text-align: center;\n  font-weight: 500;\n  letter-spacing: -0.3px;\n  margin: 0 0 10px;\n  font-size: clamp(34px, 3.2vw, 52px);\n}\n\nsection.airdrop_steps h2 span {\n  color: #1E56F5;\n}\n\n.airdrop_step_card {\n  height: 100%;\n  padding: 15px;\n  text-align: center;\n}\n\n.airdrop_step_num {\n  width: 80px;\n  height: 80px;\n  border-radius: 50px;\n  font-size: 30px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  margin-bottom: 18px;\n}\n\n.airdrop_step_num--pink {\n  background: #9810FA;\n}\n\n.airdrop_step_num--blue {\n  background: #155DFC;\n}\n\n.airdrop_step_num--green {\n  background: #00A63E;\n}\n\n.airdrop_task_social_badge i {\n  font-size: clamp(34px, 5vw, 42px);\n  line-height: 1;\n  color: #fff;\n}\n\n.airdrop_step_card h3 {\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -0.52px;\n  margin: 0 0 8px;\n}\n\n.airdrop_step_card p {\n  margin: 0px;\n  color: rgba(255, 255, 255, 0.76);\n  font-size: 18px;\n  letter-spacing: -0.38px;\n  line-height: 1.45;\n  padding-top: 3px;\n}\n\n.airdrop_section_heading {\n  text-align: center;\n}\n\n.airdrop_section_heading p {\n  margin: 0;\n  color: rgb(255 255 255 / 90%);\n  font-size: 18px;\n}\n\n.airdrop_reward_card {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 36px;\n  background-image: var(--airdrop-bonusbg);\n  background-repeat: no-repeat;\n  background-size: 100%;\n  min-height: 410px;\n}\n\n.token_rewards_sl {\n  padding-top: 24px;\n}\n\nsection.airdrop_release h2 span {\n  color: #1E56F5;\n}\n\n.airdrop_reward_top {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 2px;\n}\n\n.airdrop_reward_meta_item {\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n}\n\n.airdrop_reward_meta_item b {\n  color: #51A2FF;\n  font-weight: 400;\n}\n\n.airdrop_reward_top h3 {\n  margin: 0;\n  font-size: 30px;\n  font-weight: 600;\n}\n\n.airdrop_reward_value {\n  font-weight: 700;\n  font-size: 62px;\n  background: #51A2FF;\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.airdrop_reward_sub {\n  margin: 10px 0 12px;\n  color: rgba(255, 255, 255, 0.76);\n  font-size: 18px;\n  line-height: 1.45;\n  letter-spacing: -0.38px;\n}\n\n.airdrop_reward_meta {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 15px;\n}\n\n.airdrop_reward_meta span {\n  font-size: 18px;\n  align-items: center;\n  gap: 10px;\n  display: flex;\n  color: #D1D5DC;\n  font-weight: 300;\n}\n\n.airdrop_reward_rows {\n  display: grid;\n  gap: 10px;\n}\n\n.airdrop_reward_row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  font-size: 15px;\n}\n\n.airdrop_reward_row b {\n  font-weight: 900;\n}\n\n.airdrop_cta_row {\n  margin-top: 18px;\n  display: flex;\n  justify-content: center;\n}\n\n.airdrop_cta_link {\n  color: #fff;\n  text-decoration: none;\n  font-weight: 700;\n  font-size: 13px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.airdrop_cta_link:hover {\n  background: rgba(255, 255, 255, 0.10);\n}\n\n.airdrop_release_card {\n  height: 100%;\n  padding: 18px 18px 40px;\n  border-radius: 18px;\n  background-image: var(--airdrop-releasebg);\n  background-repeat: no-repeat;\n  background-size: cover;\n  text-align: center;\n  position: relative;\n  border: 1px solid #1e57f564;\n  overflow: hidden;\n}\n\nbody.light_theme .airdrop_release_card {\n  background-image: var(--airdrop-releasebg-light);\n}\n\nbody.light_theme .airdrop_release_sub {\n  color: rgb(0 0 0); }\n\n\nbody.light_theme .airdrop_release_time {\n    color: rgb(4 4 4 / 80%);\n}\n\nbody.light_theme .airdrop_release_badge {\n  box-shadow: none;\n  color: #fff;\n  background: #1E56F5;\n}\n\nbody.light_theme .airdropsubtext {\n  color: #656565; }\n\nsection.airdrop_release {\n  padding-bottom: 100px;\n}\n\n.airdrop_release_card::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(360px 160px at 50% 10%, rgba(72, 117, 247, 0.28), transparent 60%);\n  pointer-events: none;\n}\n\n.airdrop_release_badge {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 2;\n  font-weight: 500;\n  font-size: 15px;\n  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.9);\n  padding: 6px 32px;\n  border-radius: 18px 0px 18px 0px;\n  background: #3455B3;\n}\n\n.airdrop_release_icon {\n  position: relative;\n  z-index: 2;\n  width: 93px;\n  margin: 18px auto 12px;\n  border-radius: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.airdrop_release_card h6 {\n  font-size: 16px;\n  font-weight: 400;\n  margin: 18px 0px;\n}\n\n.airdrop_release_pct {\n  position: relative;\n  z-index: 2;\n  font-size: 40px;\n  line-height: 45px;\n  font-weight: 700;\n  margin: 0px 0 0px;\n}\n\n.airdrop_release_sub {\n  position: relative;\n  z-index: 2;\n  color: rgb(255 255 255);\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 8px;\n}\n\n.airdrop_release_time {\n  position: relative;\n  z-index: 2;\n  margin-top: 32px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.80);\n}\n\n.airdropsubtext {\n  font-size: 13px;\n  color: #b2b7bf;\n  margin-top: 9px;\n}\n\n\nbody.light_theme .airdrop_hero{ background-image: var(--airdrop-hero-light-bg) !important; }\n\nbody.light_theme img.dark_img {\n  display: none;\n}\n\nbody.light_theme img.light_img {\n  display: block;\n}\n\nimg.light_img{ display: none; }\n\nbody.light_theme .joined_user {\n  color: #787c84; }\n\n  body.light_theme .joined_user span b {\n    color: #030303;\n}  \n\n\n@media (max-width: 991px) {\n  .airdrop_stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 575px) {\n  .airdrop_hero {\n    padding-top: 52px;\n  }\n\n  .airdrop_stats {\n    grid-template-columns: 1fr;\n  }\n}\n\nbody.light_theme .airdrop_page {\n  background: radial-gradient(900px 400px at 30% 10%, rgba(129, 76, 255, 0.14), transparent 60%),\n    radial-gradient(700px 380px at 70% 20%, rgba(72, 117, 247, 0.12), transparent 60%),\n    #ffffff;\n  color: #0c0900;\n}\n\nbody.light_theme .airdrop_step_card p{\n  color: rgba(16, 16, 16, 0.7);\n}\n\nbody.light_theme .airdrop_step_num {\n  color: #fff; }\n\n  body.light_theme .airdrop_reward_sub {\n    color: rgb(0 0 0 / 76%);}  \n\nbody.light_theme .airdrop_reward_meta span {\n      color: #454545; }\n\n    body.light_theme .airdrop_section_heading p {\n        color: rgb(26 26 26 / 90%); }      \n\nbody.light_theme .airdrop_hero_content p {\n  color: rgb(4 4 4 / 95%); }\n\n/* body.light_theme .airdrop_step_card,\nbody.light_theme .airdrop_reward_card,\nbody.light_theme .airdrop_release_card,\nbody.light_theme .airdrop_stat_card,\nbody.light_theme .airdrop_cta_link,\nbody.light_theme .airdrop_social {\n  background: rgba(12, 9, 0, 0.04);\n  border: 1px solid rgba(12, 9, 0, 0.10);\n} */\n\nbody.light_theme .airdrop_btn_secondary {\n  background: rgba(12, 9, 0, 0.04);\n  border: 1px solid rgba(12, 9, 0, 0.10);\n  color: #0c0900;\n}\n\n\n@media (max-width: 1440px) {\n\n  .airdrop_visual_img {\n    max-width: min(450px, 90%);\n  }\n\n  .airdrop_hero_content h1 {\n    font-size: 75px;\n  }\n\n  .airdrop_hero_content p {\n    font-size: 20px;\n  }\n\n}\n\n\n\n@media (max-width: 1366px) {\n\n  .airdrop_visual_img {\n    max-width: min(370px, 90%);\n  }\n\n  .airdrop_hero_content h1 {\n    font-size: 60px;\n  }\n\n  .airdrop_hero_content p {\n    font-size: 18px;\n  }\n\n  .airdrop_steps h2,\n  .airdrop_rewards h2,\n  .airdrop_release h2 {\n    font-size: 38px;\n  }\n\n  section.airdrop_release {\n    padding-bottom: 60px;\n  }\n\n  .airdrop_steps,\n  .airdrop_rewards,\n  .airdrop_release {\n    padding: 60px 0 0px;\n  }\n\n  .airdrop_reward_value {\n    font-size: 40px;\n  }\n\n  .airdrop_reward_top h3 {\n    font-size: 20px;\n  }\n\n  .airdrop_reward_sub {\n    font-size: 16px;\n  }\n\n  .airdrop_reward_meta span {\n    font-size: 16px;\n  }\n\n}\n\n\n@media (max-width: 1024px) {\n  .airdrop_hero_content h1 {\n    font-size: 42px;\n  }\n\n  .airdrop_visual_img {\n    max-width: min(310px, 90%);\n  }\n\n  img.airdrop_back_img {\n    bottom: -35px;\n  }\n\n  .airdrop_step_card h3 {\n    font-size: 20px;\n  }\n\n  .airdrop_step_card p {\n    font-size: 15px;\n  }\n\n  .token_rewards_sl {\n    flex-direction: column;\n  }\n\n  .token_rewards_sl .col-lg-6 {\n    width: 100%;\n  }\n\n  .airdrop_reward_card {\n    background-size: contain;\n    min-height: 360px;\n    width: 590px;\n    margin: 0 auto;\n  }\n\n  .airdrop_release_pct {\n    font-size: 28px;\n  }\n\n\n}\n\n@media (max-width: 991px) {\n\n  .airdrop_hero {\n    padding: 40px 0 80px;\n    text-align: center;\n  }\n\n  .airdrop_hero_content h1 br {\n    display: none;\n  }\n\n  img.airdrop_back_img {\n    width: 270px;\n    margin: 0 auto;\n    right: 0px;\n  }\n\n  .airdrop_visual_img {\n    max-width: min(200px, 90%);\n    top: -30px;\n  }\n\n  .airdrop_hero_visual {\n    margin-top: 42px;\n  }\n\n  .airdrop_hero_actions {\n    justify-content: center;\n    margin: 24px 0px 22px;\n  }\n\n  .joined_user {\n    justify-content: center;\n  }\n\n\n}\n\n\n@media (max-width:767px) {\n\n  .airdrop_hero_content h1 {\n    font-size: 32px;\n  }\n\n  .airdrop_hero_content p {\n    font-size: 16px;\n    margin-bottom: 10px;\n  }\n\n  .airdrop_hero_actions {\n    gap: 10px;\n  }\n\n  .airdrop_btn_primary,\n  .airdrop_btn_secondary {\n    padding: 10px 16px;\n    font-size: 13px;\n  }\n\n  .airdrop_hero {\n    padding: 40px 0 50px;\n  }\n\n  .airdrop_stat_text h4 {\n    font-size: 24px;\n  }\n\n  .airdrop_steps h2,\n  .airdrop_rewards h2,\n  .airdrop_release h2 {\n    font-size: 26px;\n  }\n\n  .airdrop_step_num {\n    width: 60px;\n    height: 60px;\n    font-size: 22px;\n  }\n\n  .airdrop_steps, .airdrop_rewards, .airdrop_release {\n    padding: 40px 0 0px;\n} \n.token_rewards_sl {\n  padding-top: 0px;\n}\n\n.airdrop_reward_card {\n  background-size: 100% 100%;\n  width: 100%;\n  padding: 28px; }\n\n  .airdrop_reward_value {\n    font-size: 36px;\n}\n\n\n}\n\n.airdrop_steps_logged_sub {\n  text-align: center;\n  max-width: 640px;\n  margin: 12px auto 0;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 17px;\n  line-height: 1.5;\n}\n\n.airdrop_onboarding_load {\n  text-align: center;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 16px;\n}\n\n.airdrop_task_progress {\n  max-width: 900px;\n  margin: 24px auto 8px;\n  padding: 16px 18px 14px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.airdrop_task_progress_top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.airdrop_task_progress_label {\n  font-size: 15px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.airdrop_task_progress_count {\n  font-size: 14px;\n  font-weight: 500;\n  color: #7dd3fc;\n  white-space: nowrap;\n}\n\n.airdrop_task_progress_track {\n  height: 10px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  overflow: hidden;\n}\n\n.airdrop_task_progress_fill {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #155dfc 0%, #4ade80 100%);\n  transition: width 0.35s ease;\n  min-width: 0;\n}\n\n.airdrop_task_progress_steps {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.airdrop_task_progress_step {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 8px;\n}\n\n.airdrop_task_progress_icon_circle {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: rgba(255, 255, 255, 0.06);\n  border: 2px solid rgba(255, 255, 255, 0.22);\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.airdrop_task_progress_icon_circle i {\n  font-size: 20px;\n  line-height: 1;\n}\n\n.airdrop_task_progress_step.is-done .airdrop_task_progress_icon_circle {\n  background: rgba(34, 197, 94, 0.2);\n  border-color: #4ade80;\n  color: #86efac;\n  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.2);\n}\n\n.airdrop_task_progress_step.is-todo .airdrop_task_progress_icon_circle {\n  opacity: 0.88;\n}\n\n.airdrop_task_progress_stepname {\n  font-size: 12px;\n  line-height: 1.25;\n  color: rgba(255, 255, 255, 0.7);\n  word-break: break-word;\n}\n\n.airdrop_task_progress_step.is-done .airdrop_task_progress_stepname {\n  color: #86efac;\n  font-weight: 500;\n}\n\n.airdrop_task_card--done {\n  border: 1px solid rgba(0, 166, 62, 0.45);\n  border-radius: 16px;\n  background: rgba(0, 166, 62, 0.08);\n}\n\n.airdrop_task_done_badge {\n  color: #4ade80;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 6px;\n}\n\n.airdrop_task_hint {\n  font-size: 16px;\n  line-height: 1.4;\n  margin: 0 0 16px;\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.airdrop_task_actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: auto;\n  padding-top: 8px;\n}\n\n.airdrop_task_link_out {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  border-radius: 50px;\n  padding: 10px 16px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #fff;\n  background: #1e56f5;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 4px 14px rgba(30, 86, 245, 0.35);\n  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;\n}\n\n.airdrop_task_link_out:hover {\n  background: #2f64fb;\n  color: #fff;\n  box-shadow: 0 6px 18px rgba(30, 86, 245, 0.45);\n}\n\n.airdrop_task_link_out:focus-visible {\n  outline: 2px solid #93c5fd;\n  outline-offset: 2px;\n}\n\n.airdrop_task_link_out:active:not([aria-busy=\"true\"]) {\n  transform: scale(0.98);\n}\n\n.airdrop_task_mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50px;\n  padding: 10px 16px;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  color: #fff;\n  background: #1E56F5;\n  border: 1px solid transparent;\n  transition: 0.2s ease;\n}\n\n.airdrop_task_mark:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.airdrop_task_mark:hover:not(:disabled) {\n  filter: brightness(1.06);\n}\n\nbody.light_theme .airdrop_steps_logged_sub {\n  color: rgba(0, 0, 0, 0.65);\n}\n\nbody.light_theme .airdrop_task_progress {\n  background: rgba(0, 0, 0, 0.04);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\nbody.light_theme .airdrop_task_progress_label {\n  color: rgba(0, 0, 0, 0.88);\n}\n\nbody.light_theme .airdrop_task_progress_count {\n  color: #1E56F5;\n}\n\nbody.light_theme .airdrop_task_hint {\n  color: rgba(0, 0, 0, 0.7);\n}\n\nbody.light_theme .airdrop_task_link_out {\n  background: #1e56f5;\n  border-color: rgba(30, 86, 245, 0.5);\n  box-shadow: 0 4px 14px rgba(30, 86, 245, 0.25);\n}\n\nbody.light_theme .airdrop_task_link_out:hover {\n  background: #1847cf;\n}\n\nbody.light_theme .airdrop_task_link_out:focus-visible {\n  outline-color: #2563eb;\n}\n\nbody.light_theme .airdrop_task_progress_icon_circle {\n  background: rgba(0, 0, 0, 0.04);\n  border-color: rgba(0, 0, 0, 0.12);\n  color: rgba(0, 0, 0, 0.72);\n}\n\nbody.light_theme .airdrop_task_progress_step.is-done .airdrop_task_progress_icon_circle {\n  background: rgba(34, 197, 94, 0.12);\n  border-color: #22c55e;\n  color: #15803d;\n  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.18);\n}\n\nbody.light_theme .airdrop_task_progress_stepname {\n  color: rgba(0, 0, 0, 0.55);\n}\n\nbody.light_theme .airdrop_task_progress_step.is-done .airdrop_task_progress_stepname {\n  color: #15803d;\n}\n\nbody.light_theme .airdrop_task_progress_track {\n  background: rgba(0, 0, 0, 0.08);\n}\n\n@media (max-width: 767px) {\n  .airdrop_task_progress_steps {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .airdrop_task_progress_step {\n    flex-direction: row;\n    justify-content: flex-start;\n    text-align: left;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
